function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.625 7.5C7.625 5.023 9.59 3 12 3c2.408 0 4.374 2.023 4.374 4.5S14.408 12 12 12c-2.41 0-4.375-2.023-4.375-4.5zm7.437 0c0-1.748-1.363-3.15-3.062-3.15-1.7 0-3.063 1.402-3.063 3.15s1.364 3.15 3.063 3.15 3.062-1.402 3.062-3.15zM6.74 13.8c-.953 0-1.74.81-1.74 1.79v.685c0 1.622.997 2.877 2.322 3.628C8.646 20.655 10.323 21 12 21c1.676 0 3.353-.345 4.678-1.097 1.129-.64 1.979-1.665 2.217-2.953 0 0 .105-.379.105-1.36 0-.98-.788-1.79-1.741-1.79H6.74zm10.948 1.79c0-.25-.185-.44-.43-.44H6.74a.425.425 0 00-.428.44v.685c0 1.078.59 1.849 1.644 2.447 1.054.598 2.548.928 4.044.928 1.495 0 2.99-.33 4.044-.928 1.054-.599 1.643-1.369 1.643-2.447v-.685z",
  clipRule: "evenodd"
});

function SvgUserWhiteinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgUserWhiteinline;